import { render, staticRenderFns } from "./DepartmentsSlider1.vue?vue&type=template&id=2699a6b2&scoped=true&"
import script from "./DepartmentsSlider1.vue?vue&type=script&lang=js&"
export * from "./DepartmentsSlider1.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentsSlider1.vue?vue&type=style&index=0&id=2699a6b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2699a6b2",
  null
  
)

export default component.exports